class ActivityExplain {

    static getGroupSucessRate() {
        return '筛选时间内，该活动商品成团率=成团人数 / 访客数(UV)'
    }

    static getGroupTakeRate() {
        return '筛选时间内，该活动商品拼团成团转化率=成团人数 / 拼团人数'
    }

    static getSuccessCustomer() {
        return '筛选时间内， 参与该活动商品下单成团人数';
    }

    static getJoinCustomer() {
        return '筛选时间内， 参与该活动商品拼团人数';
    }

    static getAmountRate() {
        return '筛选时间内， 该活动商品费效比=营销支付金额 / 营销优惠金额';
    }

    static getDiscounted() {
        return '筛选时间内，该活动商品订单优惠金额之和';
    }

    static getReturnAmount() {
        return '筛选时间内，该活动商品成功支付订单返现金额之和';
    }

    static getEarnings() {
        return '筛选时间内，该活动商品收益金额=营销支付金额-返现金额';
    }

    static getTakeRates() {
        return '筛选时间内， 该活动商品转化率=付费用户数/访客数(UV)';
    }

    static getPayedAmount() {
        return '筛选时间内，该活动商品所有成功支付订单金额之和';
    }

    static getAllPayment() {
        return '当前活动扣除手续费和返现之后的实收金额';
    }

    static skipSwitch() {
        return '此功能默认开启，开启时只有解锁一级礼包才能解锁二级礼包';
    }

    static getChooseTime() {
        return '支持筛选3个月的数据，最长跨度不能超过90天';
    }

    static getTotalTrans() {
        return '筛选时间内，该活动全局数据，指所有访客进入页面的平均转化率=订单数/访客数(UV)';
    }

    static getOrder() {
        return '筛选时间内，该活动用户下单的订单数';
    }

    static getDistriRate() {
        return '筛选时间内，通过分享扫码进入活动页面的订单转化率=分销订单数/分销访客数(UV)';
    }

    static getDistriOrder() {
        return '筛选时间内，该活动用户通过分销下单的订单数';
    }

    static getDistriCustomer() {
        return '筛选时间内，通过分享访问该活动页面的人数';
    }

    static getPV() {
        return '筛选时间内，该活动页被访问的次数';
    }

    static getUV() {
        return '筛选时间内，该活动页被访问的人数';
    }

    static getNewCustomer() {
        return '筛选时间内，该活动商品带来的首次在店铺成交的客户数';
    }

    static getOldCustomer() {
        return '筛选时间内，在店铺有过付款订单，参与该活动商品下单的客户数';
    }

    static InGroupData() {
        return '参团数据(已参团人数/活动拼团人数)';
    }

    static getPayCustomer() {
        return '筛选时间内，成功付款购买该活动商品的用户数';
    }

    static getNotInCustomer() {
        return '筛选时间内，该活动未参与解锁礼包人数';
    }

    static getNotInvitedCus() {
        return '筛选时间内，参与该活动已解锁礼包，但未邀请好友解锁的人数';
    }

    static getInvitedNoFinished() {
        return '筛选时间内，参与该活动已解锁礼包，邀请好友但未解锁成功的人数';
    }

    static getTotalUnlock() {
        return '筛选时间内，已解锁礼包总人数(如果一人解锁多级，则按一人统计)';
    }


    static timeRange() {
        return '规定活动的时间范围。当前时间如果是活动开始时间，活动将在5分钟内自动开启。当前时间如果是活动结束时间，活动立即自动结束。';
    }

    static posterPic() {
        return '建议尺寸 1080×1920，请勿上传超过1M的图片';
    }

    static inviteType() {
        return '订阅号有二维码和邀请码两种邀请方式，服务号只有二维码一种';
    }

    static genPosterKeyword() {
        return '公众号回复关键词可参与活动';
    }

    static genPosterMsg() {
        return '和海报一起弹出，对活动的整体描述';
    }

    static sharePosterMsg() {
        return '开启后和海报一起弹出，为粉丝分享海报提供的文案'
    }

    static genQrcodeMsg() {
        return '和企业微信成员二维码一起弹出，引导用户添加企业微信好友'
    }

    static goal() {
        return '需邀请关注公众号的人数，目标为0则不开启该阶任务，保存后不可更改';
    }

    static awardType() {
        return "<div align='left'>任务完成之后给用户推送奖品。<br/>线下自定义奖品：可通过在任务完成消息中添加奖品链接</div>";
    }

    static prizesStock() {
        return '当库存为0时则不限制库存，缺货状态则活动自动结束。剩余库存=总库存-已完成任务人数'
    }

    static bindForm() {
        return "与表单关联之后，编辑消息提醒的时候即可将表单链接以变量的形式插入到消息中，粉丝完成任务填写表单之后，即可将粉丝完成情况和粉丝填写的表单信息关联，无需再人工核对"
    }

    static bindRedeencode() {
        return "与兑换码关联之后，编辑任务完成消息提醒的时候即可将兑换码以变量的形式插入到消息中粉丝完成任务即可收到唯一兑换码"
    }

    static pullProtect() {
        return '开启后如果B扫了A分享的二维码之后取关了，再扫C的二维码，也算A拉新的，关闭则算C的'
    }

    static maliceBrush() {
        return '开启后如果检测到粉丝满足刷粉条件，将把该粉丝加入黑名单，无法参加活动'
    }

    static fansType() {
        return '此项表示哪种粉丝扫码能够增加分享者的任务完成数'
    }

    static multiPoster() {
        return "若开启请务必上传不少于2张海报，粉丝获取海报将平均分配";
    }

    static taskScheduleMsg() {
        return "为了不打扰用户，造成用户取关或举报，当进度消息发送频繁时，将暂时停止发送，任务完成消息不受影响"
    }

    static repeatScanMsg() {
        return "如果粉丝重复参与，将弹出该消息和活动海报"
    }

    static taskFinishedPic() {
        return "尺寸不限,请勿上传超过200KB的图片"
    }

    static msgType() {
        return "文本消息由于微信限制，会存在粉丝收不到的情况。模板消息则不受限制，订阅号只支持文本消息，服务号支持文本和模板两种消息"
    }
}

export default ActivityExplain